export enum EIcons {
  ADMIN = 'admin',
  ACCOUNT_BALANCE = 'account-balance',
  ACTIVATE_DESTINATIONS = 'activate-destinations',
  ACTIVATE_ORIGINS = 'activate-origins',
  AIRLINE_SEAT = 'airline-seat',
  ATM = 'atm',
  ANDROID = 'android',
  arrowDropDown = 'arrow-drop-down',
  ARROW_LEFT = 'arrow-left',
  ASSIGNMENT = 'assignment',
  assignmentAcademic = 'assignment-academic',
  BLOCK = 'block',
  BUS = 'bus',
  BUS_SOLID = 'bus-solid',
  CALENDAR_BUSY = 'calendar-busy',
  CAMERA = 'camera',
  CANCEL = 'cancel',
  CARD = 'card',
  CASES = 'cases',
  CASHIER = 'cashier',
  CHECK = 'check',
  CHECK_CIRCLE = 'check-circle',
  checkbook = 'checkbook',
  CIRCLE = 'circle',
  CLIPBOARD = 'clipboard',
  CLOCK = 'clock',
  CLOSE = 'close',
  COMPRESS = 'compress-arrows',
  CONTACT = 'contact',
  COPY = 'copy',
  CREDIT_CARD = 'credit-card',
  CHEVRON_DOWN = 'chevron-down',
  chevronLeft = 'chevron-left',
  chevronRight = 'chevron-right',
  CHEVRON_UP = 'chevron-up',
  DELETE = 'delete',
  DESCRIPTION = 'description',
  DIRECT = 'direct',
  DOWNLOAD = 'download',
  DRIVERS = 'drivers',
  EDIT = 'edit',
  EDIT_LOCATION = 'edit-location',
  ELDERYLY = 'elderly',
  EMOJI = 'emoji',
  EXPAND = 'expand-arrows',
  EYE = 'eye',
  EYE_OFF = 'eye-off',
  firstPage = 'first-page',
  FILTER = 'filter',
  FILTER_OFF = 'filter-off',
  GENERATE = 'generate',
  GIFT = 'gift',
  heapSnapshot = 'heap-snapshot',
  INDIRECT = 'indirect',
  lastPage= 'last-page',
  LOGISTIC = 'logistic',
  LOG_OUT = 'log-out',
  LOYALTY = 'loyalty.svg',
  map = 'map',
  MAP_MARKED = 'map-marked',
  MARKER_ACTIVE = 'marker-active',
  MARKER_INACTIVE = 'marker-inactive',
  MENU = 'menu',
  MINUS = 'minus',
  MINUS_CIRCLE = 'minus-circle',
  MORE_VERT = 'more-vert',
  NOTIFICATIONS = 'notifications',
  ORDER_APPROVE = 'order-approve',
  OUTBOX = 'outbox',
  password = 'password',
  PAUSE = 'pause',
  PAYMENTS = 'payments',
  PENDING_ACTIONS = 'pending-actions',
  PERSON = 'person',
  PERSON_REMOVE = 'person-remove',
  PLAY = 'play',
  PLUS = 'plus',
  PLUS_CIRCLE = 'plus-circle',
  POWER_ON = 'power-on',
  PRINT = 'print',
  REBOOT = 'reboot',
  RECEIPT = 'receipt',
  RECEIVEBOX = 'receivebox',
  ROUTE = 'route',
  SCATTER_PLOT = 'scatter-plot',
  SEND = 'send',
  SEND_MONEY = 'send-money',
  SETTINGS = 'settings',
  SETTINGS_ETHERNET = 'settings-ethernet',
  SHIPPING = 'shipping',
  SIM_CARD = 'sim-card',
  SLIDERS = 'sliders',
  SORT_DOWN = 'sort-down',
  STAR = 'star',
  STOP = 'stop',
  SWAP_HORIZ = 'swap-horiz',
  SWITCH_ACCOUNT = 'switch-account',
  TABLE_ROWS = 'table-rows',
  TICKET = 'ticket',
  UPLOAD = 'upload',
  WALLET = 'wallet',
  YOUTUBE = 'youtube',
};

export const icons: any = {
  [EIcons.ADMIN]: 'assets/icon/admin.svg#admin',
  [EIcons.ACCOUNT_BALANCE]: 'assets/icon/account-balance.svg#account-balance',
  [EIcons.ACTIVATE_DESTINATIONS]: 'assets/icon/activate_destinations_call_split.svg#activate-destinations',
  [EIcons.ACTIVATE_ORIGINS]: 'assets/icon/activate_origins_call_merge.svg#activate-origins',
  [EIcons.AIRLINE_SEAT]: 'assets/icon/airline-seat.svg#airline-seat',
  [EIcons.ATM]: 'assets/icon/atm.svg#atm',
  [EIcons.ANDROID]: 'assets/icon/android.svg#android',
  [EIcons.arrowDropDown]: 'assets/icon/arrow-drop-down.svg#arrow-drop-down',
  [EIcons.ARROW_LEFT]: 'assets/icon/arrow-left.svg#arrow-left',
  [EIcons.ASSIGNMENT]: 'assets/icon/assignment.svg#assignment',
  [EIcons.assignmentAcademic]: 'assets/icon/assignment-academic.svg#assignment-academic',
  [EIcons.BLOCK]: 'assets/icon/block.svg#block',
  [EIcons.BUS]: 'assets/icon/bus.svg#bus',
  [EIcons.BUS_SOLID]: 'assets/icon/bus-solid.svg#bus-solid',
  [EIcons.CALENDAR_BUSY]: 'assets/icon/calendar-busy.svg#calendar-busy',
  [EIcons.CAMERA]: 'assets/icon/camera.svg#camera',
  [EIcons.CANCEL]: 'assets/icon/cancel.svg#cancel',
  [EIcons.CARD]: 'assets/icon/card.svg#card',
  [EIcons.CASES]: 'assets/icon/cases.svg#cases',
  [EIcons.CASHIER]: 'assets/icon/cashier.svg#cashier',
  [EIcons.CHECK]: 'assets/icon/check.svg#check',
  [EIcons.CHECK_CIRCLE]: 'assets/icon/check-circle.svg#check-circle',
  [EIcons.checkbook]: 'assets/icon/checkbook.svg#checkbook',
  [EIcons.CIRCLE]: 'assets/icon/circle.svg#circle',
  [EIcons.CLIPBOARD]: 'assets/icon/clipboard.svg#clipboard',
  [EIcons.CLOCK]: 'assets/icon/clock.svg#clock',
  [EIcons.CLOSE]: 'assets/icon/close.svg#close',
  [EIcons.COMPRESS]: 'assets/icon/compress-arrows.svg#compress-arrows',
  [EIcons.CONTACT]: 'assets/icon/contact.svg#contact',
  [EIcons.COPY]: 'assets/icon/copy.svg#copy',
  [EIcons.CREDIT_CARD]: 'assets/icon/credit-card.svg#credit-card',
  [EIcons.chevronLeft]: 'assets/icon/chevron-left.svg#chevron-left',
  [EIcons.chevronRight]: 'assets/icon/chevron-right.svg#chevron-right',
  [EIcons.CHEVRON_DOWN]: 'assets/icon/chevron-down.svg',
  [EIcons.CHEVRON_UP] : 'assets/icon/chevron-up.svg',
  [EIcons.DELETE]: 'assets/icon/delete.svg#delete',
  [EIcons.DESCRIPTION]: 'assets/icon/description.svg#description',
  [EIcons.DIRECT]: 'assets/icon/direct.svg#direct',
  [EIcons.DOWNLOAD]: 'assets/icon/download.svg#download',
  [EIcons.DRIVERS]: 'assets/icon/drivers.svg#drivers',
  [EIcons.EDIT]: 'assets/icon/edit.svg#edit',
  [EIcons.EDIT_LOCATION]: 'assets/icon/edit_location.svg#edit-location',
  [EIcons.ELDERYLY]: 'assets/icon/elderly.svg#elderly',
  [EIcons.EMOJI]: 'assets/icon/emoji.svg#emoji',
  [EIcons.EXPAND]: 'assets/icon/expand-arrows.svg#expand-arrows',
  [EIcons.EYE]: 'assets/icon/eye.svg#eye',
  [EIcons.EYE_OFF]: 'assets/icon/eye-off.svg#eye-off',
  [EIcons.FILTER]: 'assets/icon/filter.svg#filter',
  [EIcons.FILTER_OFF]: 'assets/icon/filter-off.svg#filter-off',
  [EIcons.GENERATE]: 'assets/icon/generate.svg#generate',
  [EIcons.heapSnapshot]: 'assets/icon/heap_snapshot.svg#heap-snapshot',
  [EIcons.INDIRECT]: 'assets/icon/indirect.svg#indirect',
  [EIcons.lastPage]: 'assets/icon/last-page.svg#lastPage',
  [EIcons.firstPage]: 'assets/icon/first-page.svg#firstPage',
  [EIcons.LOGISTIC]: 'assets/icon/logistic.svg#logistic',
  [EIcons.LOG_OUT]: 'assets/icon/log-out.svg#log-out',
  [EIcons.LOYALTY]: 'assets/icon/loyalty.svg#loyalty',
  [EIcons.map]: 'assets/icon/map.svg#map',
  [EIcons.MAP_MARKED]: 'assets/icon/map-marked.svg#map-marked',
  [EIcons.MARKER_ACTIVE]: 'assets/icon/marker_active.svg#marker-active',
  [EIcons.MARKER_INACTIVE]: 'assets/icon/marker_inactive.svg#marker-inactive',
  [EIcons.MENU]: 'assets/icon/menu.svg#menu',
  [EIcons.MINUS]: 'assets/icon/minus.svg#minus',
  [EIcons.MINUS_CIRCLE]: 'assets/icon/minus-circle.svg#minus-circle',
  [EIcons.MORE_VERT]: 'assets/icon/more-vert.svg#more-vert',
  [EIcons.NOTIFICATIONS]: 'assets/icon/notifications.svg#notifications',
  [EIcons.ORDER_APPROVE]: 'assets/icon/order-approve.svg#order-approve',
  [EIcons.OUTBOX]: 'assets/icon/outbox.svg#outbox',
  [EIcons.password]: 'assets/icon/password.svg#password',
  [EIcons.PAYMENTS]: 'assets/icon/payments.svg#payments',
  [EIcons.PENDING_ACTIONS]: 'assets/icon/pending-actions.svg#pending-actions',
  [EIcons.PERSON]: 'assets/icon/person.svg#person',
  [EIcons.PERSON_REMOVE]: 'assets/icon/person-remove.svg#person-remove',
  [EIcons.PLAY]: 'assets/icon/play.svg#play',
  [EIcons.PLUS]: 'assets/icon/plus.svg#plus',
  [EIcons.PLUS_CIRCLE]: 'assets/icon/plus-circle.svg#plus-circle',
  [EIcons.POWER_ON]: 'assets/icon/power-on.svg#power-on',
  [EIcons.PRINT]: 'assets/icon/print.svg#print',
  [EIcons.REBOOT]: 'assets/icon/reboot.svg#reboot',
  [EIcons.RECEIPT]: 'assets/icon/receipt.svg#receipt',
  [EIcons.RECEIVEBOX]: 'assets/icon/receivebox.svg#receivebox',
  [EIcons.ROUTE]: 'assets/icon/route.svg#route',
  [EIcons.SCATTER_PLOT]: 'assets/icon/scatter-plot.svg#scatter-plot',
  [EIcons.SEND]: 'assets/icon/send.svg#send',
  [EIcons.SEND_MONEY]: 'assets/icon/send_money.svg#send-money',
  [EIcons.SETTINGS]: 'assets/icon/settings.svg#settings',
  [EIcons.SETTINGS_ETHERNET]: 'assets/icon/settings-ethernet.svg#settings-ethernet',
  [EIcons.SHIPPING]: 'assets/icon/shipping.svg#shipping',
  [EIcons.SIM_CARD]: 'assets/icon/sim-card.svg#sim-card',
  [EIcons.SLIDERS]: 'assets/icon/sliders.svg#sliders',
  [EIcons.SORT_DOWN]: 'assets/icon/sort-down.svg#sort-down',
  [EIcons.STAR]: 'assets/icon/star.svg#star',
  [EIcons.STOP]: 'assets/icon/stop.svg#stop',
  [EIcons.SWAP_HORIZ]: 'assets/icon/swap-horiz.svg#swap-horiz',
  [EIcons.SWITCH_ACCOUNT]: 'assets/icon/switch-account.svg#switch-account',
  [EIcons.TABLE_ROWS]: 'assets/icon/table-rows.svg#table-rows',
  [EIcons.TICKET]: 'assets/icon/ticket.svg#ticket',
  [EIcons.UPLOAD]: 'assets/icon/upload.svg#upload',
  [EIcons.WALLET]: 'assets/icon/wallet.svg#wallet',
  [EIcons.YOUTUBE]: 'assets/icon/youtube.svg#youtube',
  [EIcons.PAUSE]: 'assets/icon/pause.svg#pause',
  [EIcons.GIFT]: 'assets/icon/gift.svg#gift',
};
